import React from 'react';
import { FormSectionRenderer } from '@skunexus/form';
import { useWarehousesSection } from './useWarehousesSection';

function WarehousesSection(props) {
    const { isVendorMode = false, dictionariesIsLoading = false } = props;

    const [{ warehouses, isLoading }] = useWarehousesSection(props);

    if (isVendorMode) {
        return null;
    }

    return (
        <FormSectionRenderer
            title="Warehouses"
            fields={[
                {
                    name: 'assignedWarehouses',
                    label: 'Assign to a Warehouse',
                    options: warehouses,
                    type: 'multiSelectPicker',
                },
            ]}
            sectionProps={{ isLoading: isLoading || dictionariesIsLoading }}
        />
    );
}

WarehousesSection.propTypes = {};
WarehousesSection.defaultProps = {};

export default WarehousesSection;
